import { render, staticRenderFns } from "./activeText-editor.vue?vue&type=template&id=8d097f50&scoped=true&"
import script from "./activeText-editor.vue?vue&type=script&lang=js&"
export * from "./activeText-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d097f50",
  null
  
)

export default component.exports